import React, { useState } from "react";
import PageTitle from "../../../Components/Layout/UserDashLyout/PageTitle";
import "./changepassword.css";
import { useLogin } from "../../../APIContext/LoginContext";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const ChangePassword = () => {
  const { changePasswordParentProfile } = useLogin();

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [showPassword, setShowPassword] = useState({
    old_password: false,
    new_password: false,
    confirm_password: false,
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (formData.new_password !== formData.confirm_password) {
      setError("New password and confirm password do not match!");
      return;
    }

    await changePasswordParentProfile(formData);
  };

  return (
    <>
      <PageTitle
        showDescription={false}
        showButton={false}
        title="Change Your Password"
      />

      <div className="change-password">
        <form onSubmit={handleSubmit}>
          {/* Error Alert */}
          {error && <div className="error-alert">{error}</div>}

          {/* Old Password */}
          <div className="form-group password-field">
            <label className="black-text-clip" htmlFor="old_password">
              Current password (leave blank to leave unchanged)
            </label>
            <div className="password-input-wrapper">
              <input
                type={showPassword.old_password ? "text" : "password"}
                id="old_password"
                name="old_password"
                value={formData.old_password}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() => togglePasswordVisibility("old_password")}
              >
                {showPassword.confirm_password ? (
                  <AiOutlineEyeInvisible color="#f97316" />
                ) : (
                  <AiOutlineEye color="green" />
                )}
              </span>
            </div>
          </div>

          {/* New Password */}
          <div className="form-group password-field">
            <label className="black-text-clip" htmlFor="new_password">
              New password
            </label>
            <div className="password-input-wrapper">
              <input
                type={showPassword.new_password ? "text" : "password"}
                id="new_password"
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() => togglePasswordVisibility("new_password")}
              >
                {showPassword.confirm_password ? (
                  <AiOutlineEyeInvisible color="#f97316" />
                ) : (
                  <AiOutlineEye color="green" />
                )}
              </span>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="form-group password-field">
            <label className="black-text-clip" htmlFor="confirm_password">
              Confirm New Password
            </label>
            <div className="password-input-wrapper">
              <input
                type={showPassword.confirm_password ? "text" : "password"}
                id="confirm_password"
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() => togglePasswordVisibility("confirm_password")}
              >
                {showPassword.confirm_password ? (
                  <AiOutlineEyeInvisible color="#f97316" />
                ) : (
                  <AiOutlineEye color="green" />
                )}
              </span>
            </div>
          </div>

          <button type="submit" className="btn black">
            Update Password
          </button>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
